const activity = {
  activity: "Activity",
  activities: "Activities",
  dates: "dates",
  location: "Location",
  languages: "Languages",
  categories: "Categories",
  ticketOption: "Ticket Option",
  numberOfRatings: "Number of ratings",
  meetingPointInfo: "Meeting point info",
  meetingPoint: "Meeting point",
  meetingPoints: "Meeting points",
  providedBy: "Provided by",
  expirationDate: "Expiration date",
  groupSize: "Group size",
  features: "Features",
  basedOn: "Based on",
  reviewsFromVerCustomers: "reviews from verified customers",
  excellent: "excellent",
  great: "great",
  average: "average",
  poor: "poor",
  bad: "bad",
  onlyBookedCustomersTooltip:
    "Only customers who booked this activity can leave a review",
  noReviewsYet: "At the moment, there are no reviews for this activity.",
  backToActivitiesList: "Back to activities list",
  getPrices: "get prices",
  availabilityAndPrices: "Availability and prices",
  ticketOptions: "Ticket options",
  ticketInfo: "Ticket information",
  selectYourTickets: "Select your tickets",
  product: "Product",
  total: "Total",
  slot: "Slot",
  language: "Language",
  tickets: "Tickets",
  ticketsFor: "Tickets For",
  previousStep: "Previous step",
  onlyAvailableInEnglish: "Only available in English",
  guest: "Guest",
  leadGuest: "Lead guest",
  adult: "Adult",
  child: "Child",
  pleaseSelectAdult: "Please select at least one adult",
  notAvailableActivity: "This product is not available",
  required: "Required",
  pickupPoint: "Pickup Point",
  pickupPoints: "Pickup Points",
  ticketType: "Ticket Type",
  anonymous: "Anonymous",
  printedVoucher: "Printed Voucher Accepted",
  mobileVoucher: "Mobile Voucher Accepted",
  mixedVoucher: "Mobile or printed Voucher Accepted",
  safetyMeasures: "Safety measures applied",
  doThisBecause: "Do This Because",
  safetyInfo: "Safety Info",
  reviewsHighestFirst: "Num of Reviews (highest first)",
  bookingFee: "Booking Fee",
  startDate: "Start Date",
  endDate: "End Date",
  cancellationDeadlineAndFees: "Cancellation Deadline and Fees",
  resetTickets: "Reset Tickets",
  instantConfirmation: "Instant Confirmation",
  clickResetBtn: "Click the reset button to start again your selection",
  whatToRemember: "What to remember",
};

export default activity;
